import { NgIf } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SanitizeHtmlPipePipe } from 'src/app/helpers/sanitize-html-pipe.pipe';
import { AppsSettingUrlEnum } from 'src/app/models/Lookup';
import { LookupsService } from 'src/app/services/lookups.service';
@Component({
  selector: 'app-public-page',
  templateUrl: './public-page.component.html',
  standalone: true,
  imports: [TranslateModule, NgIf, MatProgressSpinnerModule, SanitizeHtmlPipePipe, MatButtonModule],
  encapsulation: ViewEncapsulation.None
})
export class PublicPageComponent implements OnInit {
  language = localStorage.getItem('language') || 'en';
  loading = true;
  pageData!: any;
  logoSrc = './assets/images/logos/logo.svg';

  constructor(
    public router: Router,
    public lookupService: LookupsService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      if (params['pageName']) {
        this.getData(params['pageName']);
        if (
          params['pageName'] == AppsSettingUrlEnum.CustomerPrivacyPolicy
          || params['pageName'] == AppsSettingUrlEnum.CustomerTermsAndConditions
        ) {
          this.logoSrc = './assets/images/logos/app-logo.svg';
        }
      }
    });
  }
  getData(pageName: AppsSettingUrlEnum) {
    this.loading = true;
    this.lookupService.GetApplicationSettings(pageName, this.language).subscribe((data: any) => {
      this.pageData = data.data;
      this.loading = false;
    })
  }

  changeLanguage() {
    let params = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.queryParams))
    let lang = this.language == 'en' ? 'ar' : 'en'
    params['lang'] = lang;
    localStorage.setItem('language', lang);
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: params,
        queryParamsHandling: 'merge',
      });
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

}
